import {useState,useMemo} from 'react';
import {STTableProp,STTableColumnDetail} from '../STTableProps';
import { TableSortLabel,Box } from '@mui/material';
export default function TableSort(param: STTableProp, item: STTableColumnDetail) {
    const [isactive, setIsactive] = useState(false);
    const [order, setOrder] = useState(item.order)
  
    const onSortLoadData = () => {
        let sSort = isactive && order === 'asc' ? 'desc' : 'asc';
        let isActiveSort = !(isactive && order === 'desc');
        if (!param.isSortMulti && order === 'desc') {
            isActiveSort = true;
        }
        item.order = order;
        item.orderactive = true;
        setIsactive(isActiveSort);
        setOrder(sSort);
        let cloneData = { ...param.rows};
        cloneData.sSortExpression = item.field;
        cloneData.sSortDirection = order;
        param.onLoadData(cloneData);
    } 
 

    return <TableSortLabel
        active={isactive}
        direction={order === 'asc'  ? 'asc' : 'desc'}
        onClick={() => {
            onSortLoadData();
        }}
    >
        <Box component="span" >
            {item.headerName}
        </Box>
    </TableSortLabel>
}